import React, { useEffect, useState } from "react";
import axios from "axios";
import Layout from "./Layout";
import Drawer from "./Drawer";
import { baseUrl } from "../api/api";
import Loader from "./Loader";

const Calendar = () => {
  const [fixtures, setFixtures] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFixtures = async () => {
      try {
        // const res = await axios.get("http://localhost:1055/api/calendar");
        const res = await axios.get(`${baseUrl}api/calendar`);
        
        setFixtures(res.data.fixtures); // fixtures array from API
      } catch (err) {
        console.error("Error fetching fixtures:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchFixtures();
  }, []);

  if (loading) {
   return <Loader/>
    // return <p className="text-center text-red-600">Loading fixtures...</p>;
  }

  return (
    <Layout active = {9}>
        <Drawer active={9}/>
    <div className="p-6 bg-white min-h-screen">
      <h1 className="text-2xl font-bold text-center text-red-600 mb-6 flex items-center justify-center gap-2">
        📅 Kickwin's Calendar
      </h1>

      <div className="overflow-x-auto shadow-lg rounded-2xl border border-red-500">
        <table className="w-full text-sm text-left border-collapse">
          <thead className="bg-red-600 text-white text-base">
            <tr>
              <th className="px-4 py-3">Date</th>
              <th className="px-4 py-3">Time</th>
              <th className="px-4 py-3">Home Team</th>
              <th className="px-4 py-3">Away Team</th>
              <th className="px-4 py-3">Venue</th>
            </tr>
          </thead>
          <tbody>
            {fixtures.map((fixture) => {
              const date = new Date(fixture.start_date);
              const day = date.getDate();
              const month = date.toLocaleString("default", { month: "short" });
const year = date.getFullYear();
              return (
                <tr
                  key={fixture.fixture_id}
                  className="border-b hover:bg-red-50 transition"
                >
                  <td className="px-4 py-3 font-semibold text-gray-700">
                    {day} {month} {year}
                  </td>
                  <td className="px-4 py-3 text-gray-600">{fixture.time}</td>
                  <td className="px-4 py-3 font-bold text-gray-800">
                    {fixture.home_team}
                  </td>
                  <td className="px-4 py-3 font-bold text-red-600">
                    {fixture.away_team}
                  </td>
                  <td className="px-4 py-3 text-gray-600">{fixture.venue}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
    </Layout>
  );
};

export default Calendar;
